var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-card",
    { staticClass: "centered card" },
    [
      _c(
        "sui-card-content",
        [
          _c(
            "div",
            {
              staticClass: "center aligned header",
              staticStyle: { margin: "1.5em" },
            },
            [_vm._v("Reset password")]
          ),
          _vm.isEmailSent === false
            ? _c(
                "sui-form",
                { staticClass: "forgot-password-form" },
                [
                  _c(
                    "sui-form-field",
                    [
                      _c("label", [_vm._v("Email address")]),
                      _c("sui-input", {
                        attrs: {
                          type: "email",
                          placeholder: "Enter email address",
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("sui-button", {
                    attrs: {
                      content: "Send recovery link",
                      type: "button",
                      fluid: "",
                      color: "teal",
                    },
                    on: { click: _vm.forgotPassword },
                  }),
                  _c("sui-divider", { attrs: { horizontal: "" } }, [
                    _vm._v("OR"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "center aligned" },
                    [
                      _c(
                        "router-link",
                        {
                          staticStyle: { color: "#2a998b" },
                          attrs: { to: "/account/login" },
                        },
                        [_vm._v("Return to LogIn")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isEmailSent
            ? _c(
                "sui-message",
                { staticClass: "email-sent-msg", attrs: { info: "" } },
                [
                  _vm._v(
                    " Check your inbox for the next steps. If you don't receive an email, and it's not in your spam folder this could mean you signed up with a different address. "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }